// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"f0d0d409","787":"df7e483d"}[chunkId] + ".chunk.js";
};